{/* Auto-generated icon - do not edit */}
import React from 'react'

interface ChevronsLeftIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const ChevronsLeftIcon = React.forwardRef<SVGSVGElement, ChevronsLeftIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 100 93"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<path d="M10.7064 48.1114C17.149 53.6325 23.1985 59.3217 29.7705 64.3269C38.6199 71.0668 47.8545 77.3027 56.9606 83.7033C59.4671 85.4655 60.3893 87.9503 59.0937 90.1011C57.7619 92.311 54.8812 92.8401 52.5066 91.0627C40.8894 82.3662 29.2283 73.7164 17.7673 64.8132C12.7745 60.9356 8.23591 56.4777 3.4663 52.308C-0.143558 49.1576 -0.122472 46.0931 3.55171 43.0536C16.0899 32.6835 28.6195 22.3036 41.1402 11.9142C45.2489 8.4875 49.1474 4.81201 53.2534 1.3787C54.2138 0.544774 55.4274 0.0592564 56.6979 0.000488281C58.5672 0.0661221 59.2918 2.26748 58.0047 4.03434C56.7172 5.80006 55.2582 7.4341 53.6492 8.91281C40.2941 21.1728 26.9112 33.4026 13.5004 45.6022C12.703 46.3314 11.8937 47.0435 10.7064 48.1114Z" fill={color}/>
<path d="M50.0866 48.1109C56.5292 53.632 62.5788 59.3212 69.1507 64.3264C78.0001 71.0663 87.2348 77.3022 96.3408 83.7028C98.8474 85.465 99.7695 87.9498 98.4739 90.1006C97.1422 92.3105 94.2614 92.8396 91.8868 91.0622C80.2696 82.3658 68.6085 73.7159 57.1475 64.8127C52.1548 60.9351 47.6162 56.4772 42.8465 52.3075C39.2367 49.1571 39.2578 46.0926 42.932 43.0531C55.4702 32.683 67.9997 22.3031 80.5204 11.9137C84.6291 8.48701 88.5276 4.81152 92.6337 1.37821C93.594 0.544285 94.8076 0.0587681 96.0782 0C97.9474 0.0656338 98.672 2.26699 97.3849 4.03385C96.0974 5.79958 94.6385 7.43362 93.0295 8.91232C79.6743 21.1723 66.2914 33.4021 52.8807 45.6017C52.0832 46.3309 51.2739 47.043 50.0866 48.1109Z" fill={color}/>

      </svg>
    )
  }
)

ChevronsLeftIcon.displayName = 'ChevronsLeftIcon'
